import { render, staticRenderFns } from "./personAssessDetail.vue?vue&type=template&id=495d64bc&scoped=true"
import script from "./personAssessDetail.vue?vue&type=script&lang=js"
export * from "./personAssessDetail.vue?vue&type=script&lang=js"
import style0 from "./personAssessDetail.vue?vue&type=style&index=0&id=495d64bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495d64bc",
  null
  
)

export default component.exports